<template>
    <div>
        <v-row no-gutters class="mb-5">
            <v-col cols="8">
                <h1 class="headline font-weight-light mb-3">
                    Bench - Rama 3
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="text-right" cols="4" v-if="checkbox.length > 0">
                <v-btn small rounded color="success" @click="update_status()"
                    ><v-icon small class="mr-1">mdi-content-save</v-icon>
                    Save</v-btn
                >
            </v-col>
        </v-row>

        <v-row class="mar-t-20">
            <v-col cols="12">
                <v-tabs
                    v-model="tab"
                    background-color="blue accent-2"
                    class="elevation-2"
                    color="lime accent-2"
                    dark
                    :grow="true"
                >
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab
                        v-for="i in tabs_name.length"
                        :key="i"
                        :href="`#tab-${i}`"
                        @click="
                            change_tab(tabs_name[i - 1], tabs_name[i - 1].type)
                        "
                    >
                        <v-icon
                            class="mr-1"
                            v-if="tabs_name[i - 1] === actibe_tab"
                            >mdi-checkbox-marked-circle</v-icon
                        >
                        {{ tabs_name[i - 1].name }}
                        <v-chip
                            small
                            class="ml-1"
                            color="orange"
                            v-if="tabs_name[i - 1].num_cases > 0"
                        >
                            {{ tabs_name[i - 1].num_cases }}
                        </v-chip>
                    </v-tab>

                    <v-tab-item
                        v-for="i in tabs_name.length"
                        :key="i"
                        :value="'tab-' + i"
                    >
                        <div v-if="i === 1">
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th
                                                        class="text-center"
                                                        v-if="
                                                            team_name === 'ODM'
                                                        "
                                                    >
                                                        <v-btn
                                                            small
                                                            :color="colorx"
                                                            @click="all()"
                                                            rounded
                                                            >All</v-btn
                                                        >
                                                    </th>
                                                    <th class="text-center">
                                                        Case ID
                                                    </th>
                                                    <th class="text-center">
                                                        Case Title
                                                    </th>
                                                    <th class="text-center">
                                                        Created
                                                    </th>
                                                    <th class="text-center">
                                                        Product Desc.
                                                    </th>
                                                    <th class="text-center">
                                                        Product No.
                                                    </th>
                                                    <th class="text-center">
                                                        Product Serial
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-if="
                                                        data_main.length === 0
                                                    "
                                                >
                                                    <td
                                                        colspan="7"
                                                        class="text-center"
                                                    >
                                                        no results found
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-for="(row,
                                                    index) in data_main"
                                                    :key="index"
                                                >
                                                    <td
                                                        class="text-center"
                                                        v-if="
                                                            team_name === 'ODM'
                                                        "
                                                    >
                                                        <v-checkbox
                                                            v-model="checkbox"
                                                            label=""
                                                            :value="row"
                                                            color="green"
                                                        ></v-checkbox>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.case_id }}
                                                    </td>
                                                    <td>
                                                        {{ row.case_title }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.created_name }}
                                                        <v-chip x-small>{{
                                                            row.created_date
                                                        }}</v-chip>
                                                    </td>

                                                    <td>
                                                        {{
                                                            row.product_description
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{ row.product_no }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.product_serial }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>
                            </v-row>
                        </div>
                        <div v-if="i === 2">
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th
                                                        class="text-center"
                                                        v-if="
                                                            team_name ===
                                                                'BENCH RAMA3'
                                                        "
                                                    >
                                                        <v-btn
                                                            small
                                                            :color="colorx"
                                                            @click="all()"
                                                            rounded
                                                            >All</v-btn
                                                        >
                                                    </th>
                                                    <th class="text-center">
                                                        Case ID
                                                    </th>
                                                    <th class="text-center">
                                                        Case Title
                                                    </th>
                                                    <th class="text-center">
                                                        Created
                                                    </th>
                                                    <th class="text-center">
                                                        Product Desc.
                                                    </th>
                                                    <th class="text-center">
                                                        Product No.
                                                    </th>
                                                    <th class="text-center">
                                                        Product Serial
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-if="
                                                        data_main.length === 0
                                                    "
                                                >
                                                    <td
                                                        colspan="7"
                                                        class="text-center"
                                                    >
                                                        no results found
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-for="(row,
                                                    index) in data_main"
                                                    :key="index"
                                                >
                                                    <td
                                                        class="text-center"
                                                        v-if="
                                                            team_name ===
                                                                'BENCH RAMA3'
                                                        "
                                                    >
                                                        <v-checkbox
                                                            v-model="checkbox"
                                                            label=""
                                                            :value="row"
                                                            color="green"
                                                        ></v-checkbox>
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.case_id }}
                                                    </td>
                                                    <td>
                                                        {{ row.case_title }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.created_name }}
                                                        <v-chip x-small>{{
                                                            row.created_date
                                                        }}</v-chip>
                                                    </td>

                                                    <td>
                                                        {{
                                                            row.product_description
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{ row.product_no }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.product_serial }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>
                            </v-row>
                        </div>
                        <div v-if="i === 3 || i === 4">
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th
                                                        class="text-center"
                                                        v-if="
                                                            (i == 3 &&
                                                                team_name ===
                                                                    'BENCH RAMA3') ||
                                                                (i == 4 &&
                                                                    team_name ===
                                                                        'SVC')
                                                        "
                                                    >
                                                        <v-btn
                                                            small
                                                            :color="colorx"
                                                            @click="all()"
                                                            rounded
                                                            >All</v-btn
                                                        >
                                                    </th>
                                                    <th class="text-center">
                                                        Case ID
                                                    </th>
                                                    <th class="text-center">
                                                        Case Title
                                                    </th>
                                                    <th class="text-center">
                                                        Created
                                                    </th>
                                                    <th class="text-center">
                                                        Product Desc.
                                                    </th>
                                                    <th class="text-center">
                                                        Product No.
                                                    </th>
                                                    <th class="text-center">
                                                        Product Serial
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-if="
                                                        data_main.length === 0
                                                    "
                                                >
                                                    <td
                                                        colspan="7"
                                                        class="text-center"
                                                    >
                                                        no results found
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-for="(row,
                                                    index) in data_main"
                                                    :key="index"
                                                >
                                                    <td
                                                        class="text-center"
                                                        v-if="
                                                            (i == 3 &&
                                                                team_name ===
                                                                    'BENCH RAMA3') ||
                                                                (i == 4 &&
                                                                    team_name ===
                                                                        'SVC')
                                                        "
                                                    >
                                                        <v-checkbox
                                                            v-model="checkbox"
                                                            label=""
                                                            :value="row"
                                                            color="green"
                                                        ></v-checkbox>
                                                    </td>
                                                    <td class="text-center">
                                                        <v-chip
                                                            small
                                                            color="teal lighten-2"
                                                        >
                                                            {{ row.case_id }}
                                                        </v-chip>
                                                        <br />
                                                        {{ row.branch_name }}
                                                    </td>
                                                    <td>
                                                        {{ row.case_title }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.created_name }}
                                                        <v-chip x-small>{{
                                                            row.created_date
                                                        }}</v-chip>
                                                    </td>

                                                    <td>
                                                        {{
                                                            row.product_description
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{ row.product_no }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.product_serial }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <hr class="fix-hr-1" />
                                </v-col>
                            </v-row>
                        </div>
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>

        <!-- snackbar -->
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_tab()
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            this.mutateIsLoading()
            await axios
                .get(url + "odm-rama3/" + this.type, this.tk)
                .then((response) => {
                    this.data_main = response.data
                    this.checkbox = []
                    this.mutateIsLoading()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        all() {
            if (this.chk === true) {
                this.chk = false
                this.colorx = "primary"
                this.checkbox = []
            } else {
                this.chk = true
                this.colorx = "success"
                this.checkbox = this.data_main
            }
        },
        async update_status() {
            let save = {
                cases: this.checkbox,
            }
            await axios
                .post(url + "odm-rama3/" + this.type, save, this.tk)
                .then((response) => {
                    this.get_data()
                    this.mutatesnackbar()
                    setTimeout(() => {
                        this.mutatesnackbar()
                    }, 3000)
                })
                .catch((error) => {
                    this.chk_data = true
                })
        },
        async get_tab() {
            await axios
                .get(url + "odm-rama3-tab", this.tk)
                .then((response) => {
                    this.tabs_name = response.data
                    this.actibe_tab = this.tabs_name[0]
                    this.type = this.tabs_name[0].type
                    this.get_data()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        change_tab(change_tab, type) {
            this.type = type
            this.actibe_tab = change_tab
            this.data_main = []
            this.chk = false
            this.checkbox = []
            this.colorx = "primary"
            this.get_data()
        },
    },
    data() {
        return {
            data_main: [],
            team_name: localStorage.team_name,
            tab: null,
            type: null,
            text: "Success, Your work has been saved",
            tk: null,
            chk_action: false,
            actibe_tab: "",
            tabs_name: [],
            checkbox: [],
            colorx: "primary",
        }
    },
}
</script>
